/** @format */

import React, { FunctionComponent, useEffect, useState } from 'react';
import { makeStyles, TableRow } from '@material-ui/core';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import TableBody from '@material-ui/core/TableBody';
import PlatformMsisdnPoolNumber from '../../../interfaces/platform/PlatformMsisdnPoolNumber';
import Filter from '../../../interfaces/forms/Filter';
import Order from '../../../interfaces/forms/Order';
import { useDispatch, useSelector } from 'react-redux';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { StorageReducerAction, StorageReducerType } from '../../../modules/storage/StorageReducers';
import PlusNotifyInterface, { PlusNotifyCollectionInterface } from '../../../interfaces/platform/PlusNotifyInterface';
import TableCell from '@material-ui/core/TableCell';
import PagerRange from '../../../components/Adescom/PagerRange';
import TableFooter from '@material-ui/core/TableFooter';
import ViewButton from '../../../components/Buttons/ViewButton';
import I18n from '../../../components/Translate/I18n';
import { DateHelper } from '../../../helpers/DateHelper';
import { PlusNotifyHelper } from '../../../helpers/PlusNotifyHelper';
import ViewDialog from '../../../components/Dialog/ViewDialog';
import NotifyView from '../../Provisioning/components/NotifyView';
import OplAppStyle from '../../../assets/themes/OPL/jss/App/OplAppStyle';
import { withStyles } from '@material-ui/core/styles';

type MsisdnNotifyHistoryItemType = {
    classes: any;
    msisdn: PlatformMsisdnPoolNumber;
    filters: Array<Filter>;
    orders: Array<Order>;
};

const firstLoad = (dispatch: any, filters: Array<Filter>, orders: Array<Order>): void => {
    const itemLoader = new ItemLoaders(dispatch);
    itemLoader.getListWithCallback(
        FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/notifies')),
        StorageReducerAction.LOAD_STORAGE_HISTORY_NOTIFY_LIST,
        filters,
        orders,
        (data: PlusNotifyCollectionInterface): void => {
            dispatch({
                type: StorageReducerAction.LOAD_STORAGE_HISTORY_NOTIFY_LIST,
                plusNotifyCollection: data,
            } as StorageReducerType);
        },
        { propagateDataToCallback: true, dispatchAfterCallback: false }
    );
};

const MsisdnNotifyHistoryItem: FunctionComponent<MsisdnNotifyHistoryItemType> = ({ classes, msisdn, filters, orders }): React.ReactElement => {
    const { plusNotifyCollection, type } = useSelector((state: { storageReducers: StorageReducerType }) => state.storageReducers);
    const [notifyList, setNotifyList] = useState<PlusNotifyCollectionInterface | null>(null);
    const [open, setOpen] = useState(false);
    const [details, setDetails] = useState<any>(null);
    const dispatch = useDispatch();

    const tableCellRoot = { root: classes.tableCellRootBordered };
    const tableRowRoot = { root: classes.tableRowRoot };

    const pagginationCallback = (uri: string): void => {
        const itemLoader = new ItemLoaders(dispatch);
        itemLoader.paginationCallWithCallback(
            uri,
            StorageReducerAction.LOAD_STORAGE_HISTORY_NOTIFY_LIST,
            (data: PlusNotifyCollectionInterface): void => {
                dispatch({
                    type: StorageReducerAction.LOAD_STORAGE_HISTORY_NOTIFY_LIST,
                    plusNotifyCollection: data,
                });
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    useEffect(() => {
        if (type === StorageReducerAction.LOAD_STORAGE_HISTORY_NOTIFY_LIST) {
            if (plusNotifyCollection) {
                setNotifyList(plusNotifyCollection);
                dispatch({
                    type: StorageReducerAction.LOAD_STORAGE_HISTORY_NOP,
                });
                return;
            }
            firstLoad(dispatch, filters, orders);
        }
    }, [dispatch, filters, orders, type, plusNotifyCollection, notifyList]);

    const viewNotifyOn = (param: PlusNotifyInterface): void => {
        setOpen(true);
        setDetails(<NotifyView {...param} />);
    };
    const viewNotifyOff = (): void => {
        setOpen(false);
        setDetails(null);
    };

    return (
        <React.Fragment>
            <TableBody>
                {notifyList &&
                    notifyList['hydra:member'] &&
                    notifyList['hydra:member'].map((row: PlusNotifyInterface) => {
                        const desc = PlusNotifyHelper.threholdamount(row.notify.threholddirection, row.notificationType.toString());

                        return (
                            <TableRow key={'notifyList_' + row.id} classes={tableRowRoot} hover>
                                <TableCell classes={tableCellRoot} padding="none" align="left" style={{ paddingLeft: 0 }}>
                                    <ViewButton callback={viewNotifyOn} callbackParam={row} />
                                </TableCell>
                                <TableCell classes={tableCellRoot} padding="none" align="center">
                                    {row.id}
                                </TableCell>
                                {/*{Auth.getUserType() === tokenInfo.SYSTEM_TYPE_MVNO_ADMIN && (*/}
                                <React.Fragment>
                                    <TableCell classes={tableCellRoot} padding="none" align="center">
                                        {row.platformResellerName}
                                    </TableCell>
                                </React.Fragment>
                                {/*)}*/}
                                <TableCell classes={tableCellRoot} padding="none" align="center">
                                    {row.typeGroupId && <I18n trans={PlusNotifyHelper.notificationGroupType(row.typeGroupId.toString())} />}
                                </TableCell>
                                <TableCell classes={tableCellRoot} padding="none" align="center">
                                    {row.notify.threholddirection && <I18n trans={'prov:list.' + row.notify.threholddirection} />}
                                    {!row.notify.threholddirection && <I18n trans={'prov:list.NONE'} />}
                                </TableCell>
                                <TableCell classes={tableCellRoot} padding="none" align="center">
                                    {row.description}
                                </TableCell>
                                <TableCell classes={tableCellRoot} padding="none" align="center">
                                    {DateHelper.format(row.eventDate)}
                                </TableCell>
                                <TableCell classes={tableCellRoot} padding="none" align="center">
                                    {DateHelper.format(row.createdAt)}
                                </TableCell>
                            </TableRow>
                        );
                    })}
            </TableBody>
            <TableFooter>
                <TableRow>
                    <TableCell colSpan={4}>
                        {notifyList && notifyList['hydra:view'] && <PagerRange callback={pagginationCallback} views={notifyList} />}
                        <ViewDialog
                            maxWidth="lg"
                            title={'prov:list.view_notification'}
                            content={details}
                            agreeButtonName={'general:common.close'}
                            open={open}
                            callBackDisAgree={viewNotifyOff}
                        />
                    </TableCell>
                </TableRow>
            </TableFooter>
        </React.Fragment>
    );
};

export default withStyles(OplAppStyle)(MsisdnNotifyHistoryItem);
